import { Card, Tabs } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingElement from '../../../components/LoadingElement';
import { useDashboardContext } from './DashboardContext';
import { type TopSalesManData } from './data/useTopSalesManWithApplicationData';
import useTopSalesManWithLoanData from './data/useTopSalesManWithLoanData';
import TopSalesManTable from './shared/TopSalesManTable';
import useActiveTabPane from './shared/useActiveTabPane';
import useSeriesFields from './shared/useSeriesField';

export const TopSalesManWithLoanViewID = 'topSalesManWithLoan';

const TopSalesManWithLoan = () => {
    const { t } = useTranslation(['dashboard']);
    const [data, setData] = useState<TopSalesManData>(null);
    const { isLoading, error, generateData } = useTopSalesManWithLoanData();

    const { currentMonth, lastMonth } = useSeriesFields();

    const { activeTabPaneKey, setActiveTabPaneKey } = useActiveTabPane();
    const onChange = useCallback(
        (key: string) => {
            setActiveTabPaneKey(key);
        },
        [setActiveTabPaneKey]
    );

    useEffect(() => {
        generateData(result => setData(result));
    }, [generateData, setData]);

    const { setVisible } = useDashboardContext();

    useEffect(() => {
        setVisible({ [TopSalesManWithLoanViewID]: !error });
    }, [error, setVisible]);

    if (isLoading) {
        return <LoadingElement />;
    }

    if (error) {
        return null;
    }

    return (
        <Card title={t('dashboard:topSalesManWithLoan.title')}>
            <Tabs
                activeKey={activeTabPaneKey}
                items={[
                    {
                        label: currentMonth,
                        key: '1',
                        children: <TopSalesManTable columns={data?.columns} dataSource={data?.data?.currentMonth} />,
                    },
                    {
                        label: lastMonth,
                        key: '2',
                        children: <TopSalesManTable columns={data?.columns} dataSource={data?.data?.lastMonth} />,
                    },
                ]}
                onChange={onChange}
                type="card"
            />
        </Card>
    );
};

export default TopSalesManWithLoan;
